(function () {
    'use strict';

    angular.module('NaviaqWebApp').directive('finalReportLegalPageAbyssDirective', finalReportLegalPageAbyssDirective);

    finalReportLegalPageAbyssDirective.$inject = [];
    function finalReportLegalPageAbyssDirective() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/report/clients/Abyss/finalReportComponents/final-report-legal-page-abyss.html',
            scope: {
                data: '=data'
            },
            link: function (scope, element, attrs) {
            },
        };
    }
})();
